// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"a6b5f3b7","36":"91ada27e","54":"5241e8a0","149":"35ed2e63","341":"250af722","791":"67f50d6a"}[chunkId] + ".chunk.css";
};